// The cache key of the address read ([AS-037]), defined ONCE for the two slices that share it: the
// header's address search (`location-search`) and the «Usuario» ficha's address combobox
// (`user-card`). Sharing the key is what makes the ficha's field reuse an answer the header
// already fetched; two matching literals in two slices would be the same intent with none of the
// guarantee. It lives here and not in either slice because neither may import the other —
// `user-card->location-search` is an edge outside `scripts/layout-allowed-edges.txt`.
export const locationSearchKey = (term: string): readonly unknown[] => ['location-search', term];
